<template>
  <TheHeader />
  <div class="e4s-body-wrapper">
    <div class="e4s-flex-row e4s-body-wrapper--router-content e4s-justify-flex-center">
      <!--##dynamic width-->
      <RouterView :key="route.fullPath" class="e4s-flex-column e4s-width-controller" />
    </div>

    <!--    <LaunchFooterV2 />-->
  </div>
</template>
<script setup lang="ts">
import { RouterView } from 'vue-router'
import TheHeader from '@/components/TheHeader.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
</script>
